console.log('OpenCOTS Order List JS: Loading custom elements...');

// Check for required dependencies
if (typeof fetchConfig === 'undefined') {
  console.error('OpenCOTS Order List: fetchConfig not available, waiting for global.js');
}
if (typeof debounce === 'undefined') {
  console.error('OpenCOTS Order List: debounce not available, waiting for global.js');
}
if (typeof subscribe === 'undefined') {
  console.error('OpenCOTS Order List: subscribe not available, waiting for pubsub.js');
}
if (typeof publish === 'undefined') {
  console.error('OpenCOTS Order List: publish not available, waiting for pubsub.js');
}
if (typeof PUB_SUB_EVENTS === 'undefined') {
  console.error('OpenCOTS Order List: PUB_SUB_EVENTS not available, waiting for constants.js');
}
if (typeof ON_CHANGE_DEBOUNCE_TIMER === 'undefined') {
  console.error('OpenCOTS Order List: ON_CHANGE_DEBOUNCE_TIMER not available, waiting for constants.js');
}

if (!customElements.get('opencots-order-list-remove-button')) {
  customElements.define(
    'opencots-order-list-remove-button',
    class OpencotsOrderListRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const opencotsOrderList = this.closest('opencots-order-list');
          opencotsOrderList.updateQuantity(this.dataset.index, 0);
        });
      }
    }
  );
}

if (!customElements.get('opencots-order-list-remove-all-button')) {
  customElements.define(
    'opencots-order-list-remove-all-button',
    class OpencotsOrderListRemoveAllButton extends HTMLElement {
      constructor() {
        super();
        this.opencotsOrderList = this.closest('opencots-order-list');
        const allVariants = this.opencotsOrderList.querySelectorAll('[data-quantity-variant-id]');
        const items = {};
        let hasVariantsInCart = false;

        allVariants.forEach((variant) => {
          const cartQty = parseInt(variant.dataset.cartQuantity);
          if (cartQty > 0) {
            hasVariantsInCart = true;
            items[parseInt(variant.dataset.quantityVariantId)] = 0;
          }
        });

        if (!hasVariantsInCart) {
          this.classList.add('hidden');
        }

        this.actions = {
          confirm: 'confirm',
          remove: 'remove',
          cancel: 'cancel',
        };

        this.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.dataset.action === this.actions.confirm) {
            this.toggleConfirmation(false, true);
          } else if (this.dataset.action === this.actions.remove) {
            this.opencotsOrderList.updateMultipleQty(items);
            this.toggleConfirmation(true, false);
          } else if (this.dataset.action === this.actions.cancel) {
            this.toggleConfirmation(true, false);
          }
        });
      }

      toggleConfirmation(showConfirmation, showInfo) {
        this.opencotsOrderList
          .querySelector('.opencots-order-list-total__confirmation')
          .classList.toggle('hidden', showConfirmation);
        this.opencotsOrderList.querySelector('.opencots-order-list-total__info').classList.toggle('hidden', showInfo);
      }
    }
  );
}

if (!customElements.get('opencots-order-list')) {
  customElements.define(
    'opencots-order-list',
    class OpencotsOrderList extends HTMLElement {
      constructor() {
        super();
        console.log('OpenCOTS Order List: Constructor called');
        this.cart = document.querySelector('cart-drawer');
        this.actions = {
          add: 'ADD',
          update: 'UPDATE',
        };

        this.opencotsOrderListId = `opencots-order-list-${this.dataset.id}`;
        this.defineInputsAndOpencotsOrderTable();

        this.variantItemStatusElement = document.getElementById('opencots-shopping-cart-variant-item-status');
        const form = this.querySelector('form');
        const quantityWrapper = this.querySelector('.variant-item__quantity-wrapper');
        this.inputFieldHeight = quantityWrapper ? quantityWrapper.offsetHeight : 0;
        this.isListInsideModal = document.querySelector('.quick-add-bulk');
        this.stickyHeaderElement = document.querySelector('sticky-header');
        this.getTableHead();
        this.getTotalBar();

        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute('data-sticky-type')}`,
          };
        }

        if (this.getTotalBar()) {
          this.totalBarPosition = window.innerHeight - this.getTotalBar().offsetHeight;

          window.addEventListener('resize', () => {
            this.totalBarPosition = window.innerHeight - this.getTotalBar().offsetHeight;
            this.stickyHeader.height = this.stickyHeaderElement ? this.stickyHeaderElement.offsetHeight : 0;
          });
        }

        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
        form.addEventListener('submit', this.onSubmit.bind(this));
        this.addMultipleDebounce();
      }

      cartUpdateUnsubscriber = undefined;

      onSubmit(event) {
        event.preventDefault();
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === this.opencotsOrderListId) {
            return;
          }
          // If its another section that made the update
          this.refresh().then(() => {
            this.defineInputsAndOpencotsOrderTable();
            this.addMultipleDebounce();
            // Task 210: Do NOT re-enforce minimums after refresh
            // Preserves user's current cart state and selections
            // REMOVED: this.enforceMinimumQuantities();
          });
        });
        this.sectionId = this.dataset.id;

        // Task 210: Do NOT enforce minimums on page load
        // Prevents auto-adding components to cart when tab loads
        // MOQ is still enforced via:
        //   - HTML5 min attribute on inputs
        //   - validateQuantity() on user interaction (lines 433-453)
        //   - autoAdjustQuantityToMinimum() on variant change events
        // REMOVED: this.enforceMinimumQuantities();

        // Task 068: Initialize Download Design Pack button
        this.initializeDownloadDesignPackButton();

        // Task 133: Initialize Custom Design Quote button and manufacture step progression
        this.initializeCustomDesignQuoteButton();
      }

      // Task 068: Download Design Pack Button Functionality
      initializeDownloadDesignPackButton() {
        const downloadBtn = document.getElementById('download-design-pack-btn');
        
        if (downloadBtn && !downloadBtn.hasAttribute('data-opencots-initialized')) {
          // Mark as initialized to prevent duplicate listeners
          downloadBtn.setAttribute('data-opencots-initialized', 'true');
          
          downloadBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleDownloadDesignPack();
            
            // Task 133: Trigger manufacture step progression
            this.triggerManufactureStepProgression('download-design-pack');
          });
        }
      }

      // Task 133: Custom Design Quote Button Functionality
      initializeCustomDesignQuoteButton() {
        const customQuoteBtn = document.getElementById('custom-design-quote-btn');
        
        if (customQuoteBtn && !customQuoteBtn.hasAttribute('data-opencots-initialized')) {
          // Mark as initialized to prevent duplicate listeners
          customQuoteBtn.setAttribute('data-opencots-initialized', 'true');
          
          customQuoteBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.handleCustomDesignQuote();
            
            // Task 133: Trigger manufacture step progression
            this.triggerManufactureStepProgression('custom-design-quote');
          });
        }
      }

      handleCustomDesignQuote() {
        console.log('🔄 Custom design quote button clicked');
        
        // For now, this could open a modal, redirect to a form, or perform other actions
        // The main goal is to trigger the manufacture step progression
        console.log('📋 Custom design quote request initiated');
        
        // Future implementation: Could show a different modal or redirect to a quote form
        // alert('Custom design quote functionality - coming soon!');
      }

      // Task 133: Trigger Manufacture Step Progression
      triggerManufactureStepProgression(buttonType) {
        console.log(`🎯 Task 133: Triggering manufacture step progression from: ${buttonType}`);
        
        // Dispatch the manufacture ready event to update the config menu
        const manufactureReadyEvent = new CustomEvent('opencots:manufacture:ready', {
          detail: {
            source: 'order-list-forms',
            buttonType: buttonType,
            timestamp: new Date().toISOString(),
            message: `User interacted with ${buttonType} - ready for manufacture step`
          }
        });
        
        window.dispatchEvent(manufactureReadyEvent);
        console.log(`✅ Task 133: opencots:manufacture:ready event dispatched for ${buttonType}`);
      }

      handleDownloadDesignPack() {
        console.log('🔄 Collecting OpenCOTS product data for design pack...');
        
        try {
          // Get product data from JSON script tag (metafields pre-extracted server-side)
          const productDataScript = document.getElementById(`opencots-product-data-${this.dataset.id}`);
          if (!productDataScript) {
            console.error('❌ Product data not found');
            return;
          }
          
          const productsData = JSON.parse(productDataScript.textContent);
          const productData = [];
          
          // Process each product type (data already extracted from Liquid)
          ['heatframe', 'wedgelock', 'ejectorLeft', 'ejectorRight'].forEach(productType => {
            if (productsData[productType]) {
              const productInfo = {
                sku: productsData[productType].sku,
                productTitle: productsData[productType].productTitle,
                variantTitle: productsData[productType].variantTitle,
                link: productsData[productType].link,
                fusionLink: productsData[productType].fusionLink
              };
              
              // Add new fields if they exist
              if (productsData[productType].datasheetLink) {
                productInfo.datasheetLink = productsData[productType].datasheetLink;
              }
              if (productsData[productType].pcbPDFLink) {
                productInfo.pcbPDFLink = productsData[productType].pcbPDFLink;
              }
              if (productsData[productType].pcbDXFLink) {
                productInfo.pcbDXFLink = productsData[productType].pcbDXFLink;
              }
              
              productData.push(productInfo);
            }
          });
          
          // Check if we have products to request
          if (productData.length === 0) {
            console.log('⚠️  No configured products found in order list');
            alert('No products configured. Please configure your OpenCOTS setup first.');
            return;
          }
          
          console.log('📦 OpenCOTS Design Pack Data:', productData);
          console.log(`✅ Found ${productData.length} configured products for design pack`);
          
          // Format product data as JSON for email
          const emailData = {
            requestType: "Design Pack Request",
            products: productData
          };
          
          const finalJsonString = JSON.stringify(emailData, null, 2);
          
          // Show the modal form
          this.showDesignPackModal(finalJsonString);
          
        } catch (error) {
          console.error('❌ Error processing design pack data:', error);
        }
      }

      // Task 069: Show Design Pack Request Modal
      showDesignPackModal(productDataJson) {
        const modal = document.getElementById('design-pack-request-modal');
        if (!modal) {
          console.error('❌ Design Pack modal not found');
          return;
        }

        // Populate the hidden product data field
        const productDataFields = modal.querySelectorAll('#design-pack-products-requested');
        productDataFields.forEach(field => {
          field.value = productDataJson;
        });

        // Show the modal
        modal.style.display = 'block';
        
        // Add backdrop blur effect to main content
        document.body.classList.add('modal-open-blur');
        
        // Setup modal event listeners if not already done
        if (!modal.hasAttribute('data-events-initialized')) {
          this.initializeDesignPackModalEvents(modal);
          modal.setAttribute('data-events-initialized', 'true');
        }
      }

      // Task 069: Initialize Design Pack Modal Events
      initializeDesignPackModalEvents(modal) {
        // Close modal handlers
        const closeButtons = modal.querySelectorAll('.design-pack-modal-close');
        const overlay = modal.querySelector('.design-pack-modal-overlay');
        
        const closeModal = () => {
          modal.style.display = 'none';
          document.body.classList.remove('modal-open-blur');
        };
        
        closeButtons.forEach(btn => {
          btn.addEventListener('click', closeModal);
        });
        
        if (overlay) {
          overlay.addEventListener('click', closeModal);
        }
        
        // ESC key to close modal
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.style.display === 'block') {
            closeModal();
          }
        });

        // Handle logged-out user form reveal
        const loggedOutButton = modal.querySelector('#design-pack-request-logged-out');
        const buttonContainer = modal.querySelector('#design-pack-button-container');
        const formContainer = modal.querySelector('#design-pack-form-container');
        
        if (loggedOutButton && buttonContainer && formContainer) {
          loggedOutButton.addEventListener('click', () => {
            buttonContainer.style.display = 'none';
            formContainer.style.display = 'block';
          });
        }

        // Handle login button with page refresh on return
        const loginButton = modal.querySelector('#design-pack-login-button');
        if (loginButton) {
          loginButton.addEventListener('click', () => {
            localStorage.setItem('reloadOnReturn', 'true');
          });
        }

        // Check for page visibility change to reload after login
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && localStorage.getItem('reloadOnReturn') === 'true') {
            localStorage.removeItem('reloadOnReturn');
            location.reload();
          }
        });
      }


      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        
        // Task 068: Cleanup Download Design Pack button
        const downloadBtn = document.getElementById('download-design-pack-btn');
        if (downloadBtn) {
          downloadBtn.removeAttribute('data-opencots-initialized');
        }
        
        // Task 133: Cleanup Custom Design Quote button
        const customQuoteBtn = document.getElementById('custom-design-quote-btn');
        if (customQuoteBtn) {
          customQuoteBtn.removeAttribute('data-opencots-initialized');
        }
      }

      defineInputsAndOpencotsOrderTable() {
        this.allInputsArray = Array.from(this.querySelectorAll('input[type="number"]'));
        this.opencotsOrderListTable = this.querySelector('.opencots-order-list__table');
        this.opencotsOrderListTable.addEventListener('focusin', this.switchVariants.bind(this));
      }

      onChange(event) {
        // Task 170/171: Skip full kit inputs - they have their own handler
        const index = event.target.dataset.index;
        if (index === 'full-kit') {
          console.log('Task 170: Skipping OpencotsOrderList onChange for full kit input');
          return;
        }

        const inputValue = parseInt(event.target.value);
        const cartQuantity = parseInt(event.target.dataset.cartQuantity);
        const name = document.activeElement.getAttribute('name');

        const quantity = inputValue - cartQuantity;
        this.cleanErrorMessageOnType(event);
        if (inputValue == 0) {
          this.updateQuantity(index, inputValue, name, this.actions.update);
        } else {
          this.validateQuantity(event, name, index, inputValue, cartQuantity, quantity);
        }
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener('keydown', () => {
          event.target.setCustomValidity(' ');
          event.target.reportValidity();
        });
      }

      validateQuantity(event, name, index, inputValue, cartQuantity, quantity) {
        if (inputValue < event.target.dataset.min) {
          this.setValidity(
            event,
            index,
            window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min)
          );
        } else if (inputValue > parseInt(event.target.max)) {
          this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
          this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
          event.target.setCustomValidity('');
          event.target.reportValidity();
          if (cartQuantity > 0) {
            this.updateQuantity(index, inputValue, name, this.actions.update);
          } else {
            this.updateQuantity(index, quantity, name, this.actions.add);
          }
        }
      }

      setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
      }

      validateInput(target) {
        if (target.max) {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) <= parseInt(target.max) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          );
        } else {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          );
        }
      }

      refresh() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#${this.opencotsOrderListId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsToRender() {
        return [
          {
            id: this.opencotsOrderListId,
            section: document.getElementById(this.opencotsOrderListId).dataset.id,
            selector: `#${this.opencotsOrderListId} .js-contents`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: `opencots-order-list-live-region-text-${this.dataset.id}`,
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: `opencots-order-list-total-${this.dataset.id}`,
            section: document.getElementById(this.opencotsOrderListId).dataset.id,
            selector: `#${this.opencotsOrderListId} .opencots-order-list__total`,
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      addMultipleDebounce() {
        this.querySelectorAll('quantity-input').forEach((qty) => {
          const debouncedOnChange = debounce((event) => {
            this.onChange(event);
          }, ON_CHANGE_DEBOUNCE_TIMER);
          qty.addEventListener('change', debouncedOnChange.bind(this));
        });
      }

      addDebounce(id) {
        const element = this.querySelector(`#OpencotsVariant-${id} quantity-input`);
        const debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);
        element.addEventListener('change', debouncedOnChange.bind(this));
      }

      // Task 200: Auto-adjust quantity when variant minimum changes
      autoAdjustQuantityToMinimum(variantId) {
        const quantityInput = this.querySelector(`input[data-quantity-variant-id="${variantId}"]`);
        if (!quantityInput) return;

        const currentQty = parseInt(quantityInput.value) || 0;
        const minQty = parseInt(quantityInput.getAttribute('min')) || 0;

        // Only auto-adjust UP, never down
        if (currentQty < minQty && minQty > 0) {
          console.log(`Task 200: Auto-adjusting quantity from ${currentQty} to ${minQty} (variant minimum) for variant ${variantId}`);
          quantityInput.value = minQty;

          // Trigger change event to update cart
          const changeEvent = new Event('change', { bubbles: true });
          quantityInput.dispatchEvent(changeEvent);
        }
      }

      // Task 200: Check all quantity inputs for minimum enforcement
      // Task 210: NO LONGER called on page load to prevent auto-cart-add
      // Only call this in response to explicit user actions (e.g., variant selection)
      // Not currently used - may be used in future for explicit variant change handling
      enforceMinimumQuantities() {
        this.querySelectorAll('input[data-quantity-variant-id]').forEach((input) => {
          const variantId = input.getAttribute('data-quantity-variant-id');
          if (variantId) {
            this.autoAdjustQuantityToMinimum(variantId);
          }
        });
      }

      renderSections(parsedState, id) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');
            setTimeout(() => {
              document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            if (section.selector === `#${this.opencotsOrderListId} .js-contents` && id !== undefined) {
              elementToReplace.querySelector(`#OpencotsVariant-${id}`).innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                `#OpencotsVariant-${id}`
              );
            } else {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });
        this.defineInputsAndOpencotsOrderTable();
        if (id) {
          this.addDebounce(id);
        } else {
          this.addMultipleDebounce();
        }
      }

      getTableHead() {
        return document.querySelector('.opencots-order-list__table thead');
      }

      getTotalBar() {
        return this.querySelector('.opencots-order-list__total');
      }

      scrollOpencotsOrderListTable() {
        const inputTopBorder = this.variantListInput.getBoundingClientRect().top;
        const inputBottomBorder = this.variantListInput.getBoundingClientRect().bottom;

        if (this.isListInsideModal) {
          const totalBarCrossesInput = inputBottomBorder > this.getTotalBar().getBoundingClientRect().top;
          const tableHeadCrossesInput = inputTopBorder < this.getTableHead().getBoundingClientRect().bottom;

          if (totalBarCrossesInput || tableHeadCrossesInput) {
            this.scrollToCenter();
          }
        } else {
          const stickyHeaderBottomBorder =
            this.stickyHeaderElement && this.stickyHeaderElement.getBoundingClientRect().bottom;
          const totalBarCrossesInput = inputBottomBorder > this.totalBarPosition;
          const inputOutsideOfViewPort = inputBottomBorder < this.inputFieldHeight;
          const stickyHeaderCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type !== 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder;
          const stickyHeaderScrollupCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type === 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder &&
            stickyHeaderBottomBorder > 0;

          if (
            totalBarCrossesInput ||
            inputOutsideOfViewPort ||
            stickyHeaderCrossesInput ||
            stickyHeaderScrollupCrossesInput
          ) {
            this.scrollToCenter();
          }
        }
      }

      scrollToCenter() {
        this.variantListInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }

      switchVariants(event) {
        if (event.target.tagName !== 'INPUT') {
          return;
        }

        this.variantListInput = event.target;
        this.variantListInput.select();
        if (this.allInputsArray.length !== 1) {
          this.variantListInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.target.blur();
              if (this.validateInput(e.target)) {
                const currentIndex = this.allInputsArray.indexOf(e.target);
                this.lastKey = e.shiftKey;
                if (!e.shiftKey) {
                  const nextIndex = currentIndex + 1;
                  const nextVariant = this.allInputsArray[nextIndex] || this.allInputsArray[0];
                  nextVariant.select();
                } else {
                  const previousIndex = currentIndex - 1;
                  const previousVariant =
                    this.allInputsArray[previousIndex] || this.allInputsArray[this.allInputsArray.length - 1];
                  this.lastElement = previousVariant.dataset.index;
                  previousVariant.select();
                }
              }
            }
          });

          this.scrollOpencotsOrderListTable();
        } else {
          this.variantListInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.target.blur();
            }
          });
        }
      }

      updateMultipleQty(items) {
        this.querySelector('.variant-remove-total .loading__spinner').classList.remove('hidden');

        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        this.updateMessage();
        this.setErrorMessage();

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState);
          })
          .catch(() => {
            this.setErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.querySelector('.variant-remove-total .loading__spinner').classList.add('hidden');
          });
      }

      getSectionsUrl() {
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
          return `${window.location.pathname}`;
        }
      }

      updateQuantity(id, quantity, name, action) {
        this.toggleLoading(id, true);
        this.cleanErrors();

        let routeUrl = routes.cart_change_url;
        let body = JSON.stringify({
          quantity,
          id,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });
        let fetchConfigType;
        if (action === this.actions.add) {
          fetchConfigType = 'javascript';
          routeUrl = routes.cart_add_url;
          body = JSON.stringify({
            items: [
              {
                quantity: parseInt(quantity),
                id: parseInt(id),
              },
            ],
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: this.getSectionsUrl(),
          });
        }

        this.updateMessage();
        this.setErrorMessage();

        fetch(`${routeUrl}`, { ...fetchConfig(fetchConfigType), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            const quantityElement = document.getElementById(`OpencotsQuantity-${id}`);
            const items = document.querySelectorAll('.variant-item');

            if (parsedState.description || parsedState.errors) {
              const variantItem = document.querySelector(
                `[id^="OpencotsVariant-${id}"] .variant-item__totals.small-hide .loading__spinner`
              );
              variantItem.classList.add('loading__spinner--error');
              this.resetQuantityInput(id, quantityElement);
              if (parsedState.errors) {
                this.updateLiveRegions(id, parsedState.errors);
              } else {
                this.updateLiveRegions(id, parsedState.description);
              }
              return;
            }

            this.classList.toggle('is-empty', parsedState.item_count === 0);

            this.renderSections(parsedState, id);

            let hasError = false;

            const currentItem = parsedState.items.find((item) => item.variant_id === parseInt(id));
            const updatedValue = currentItem ? currentItem.quantity : undefined;
            if (updatedValue && updatedValue !== quantity) {
              this.updateError(updatedValue, id);
              hasError = true;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: this.opencotsOrderListId, cartData: parsedState });

            if (hasError) {
              this.updateMessage();
            } else if (action === this.actions.add) {
              this.updateMessage(parseInt(quantity));
            } else if (action === this.actions.update) {
              this.updateMessage(parseInt(quantity - quantityElement.dataset.cartQuantity));
            } else {
              this.updateMessage(-parseInt(quantityElement.dataset.cartQuantity));
            }
          })
          .catch((error) => {
            this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
            this.resetQuantityInput(id);
            console.error(error);
            this.setErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.toggleLoading(id);
            if (this.lastKey && this.lastElement === id) {
              this.querySelector(`#OpencotsVariant-${id} input`).select();
            }
          });
      }

      resetQuantityInput(id, quantityElement) {
        const input = quantityElement ?? document.getElementById(`OpencotsQuantity-${id}`);
        input.value = input.getAttribute('value');
      }

      setErrorMessage(message = null) {
        this.errorMessageTemplate =
          this.errorMessageTemplate ??
          document.getElementById(`OpencotsOrderListErrorTemplate-${this.dataset.id}`).cloneNode(true);
        const errorElements = document.querySelectorAll('.opencots-order-list-error');

        errorElements.forEach((errorElement) => {
          errorElement.innerHTML = '';
          if (!message) return;
          const updatedMessageElement = this.errorMessageTemplate.cloneNode(true);
          updatedMessageElement.content.querySelector('.opencots-order-list-error-message').innerText = message;
          errorElement.appendChild(updatedMessageElement.content);
        });
      }

      updateMessage(quantity = null) {
        const messages = this.querySelectorAll('.opencots-order-list__message-text');
        const icons = this.querySelectorAll('.opencots-order-list__message-icon');

        if (quantity === null || isNaN(quantity)) {
          messages.forEach((message) => (message.innerHTML = ''));
          icons.forEach((icon) => icon.classList.add('hidden'));
          return;
        }

        const isQuantityNegative = quantity < 0;
        const absQuantity = Math.abs(quantity);

        const textTemplate = isQuantityNegative
          ? absQuantity === 1
            ? window.quickOrderListStrings.itemRemoved
            : window.quickOrderListStrings.itemsRemoved
          : quantity === 1
          ? window.quickOrderListStrings.itemAdded
          : window.quickOrderListStrings.itemsAdded;

        messages.forEach((msg) => (msg.innerHTML = textTemplate.replace('[quantity]', absQuantity)));

        if (!isQuantityNegative) {
          icons.forEach((i) => i.classList.remove('hidden'));
        }
      }

      updateError(updatedValue, id) {
        let message = '';
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        this.updateLiveRegions(id, message);
      }

      cleanErrors() {
        this.querySelectorAll('.desktop-row-error').forEach((error) => error.classList.add('hidden'));
        this.querySelectorAll(`.variant-item__error-text`).forEach((error) => (error.innerHTML = ''));
      }

      updateLiveRegions(id, message) {
        const variantItemErrorDesktop = document.getElementById(`Opencots-order-list-item-error-desktop-${id}`);
        const variantItemErrorMobile = document.getElementById(`Opencots-order-list-item-error-mobile-${id}`);
        if (variantItemErrorDesktop) {
          variantItemErrorDesktop.querySelector('.variant-item__error-text').innerHTML = message;
          variantItemErrorDesktop.closest('tr').classList.remove('hidden');
        }
        if (variantItemErrorMobile)
          variantItemErrorMobile.querySelector('.variant-item__error-text').innerHTML = message;

        this.variantItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('opencots-order-list-live-region-text');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      toggleLoading(id, enable) {
        const opencotsOrderListItems = this.querySelectorAll(`#OpencotsVariant-${id} .loading__spinner`);
        const opencotsOrderListItem = this.querySelector(`#OpencotsVariant-${id}`);

        if (enable) {
          opencotsOrderListItem.classList.add('opencots-order-list__container--disabled');
          [...opencotsOrderListItems].forEach((overlay) => overlay.classList.remove('hidden'));
          this.variantItemStatusElement.setAttribute('aria-hidden', false);
        } else {
          opencotsOrderListItem.classList.remove('opencots-order-list__container--disabled');
          opencotsOrderListItems.forEach((overlay) => overlay.classList.add('hidden'));
        }
      }
    }
  );
}